// extracted by mini-css-extract-plugin
module.exports = {"tableView":"IndianStatesTable_tableView__19VlS","MuiTableCell-root":"IndianStatesTable_MuiTableCell-root__2YTnx"};